import {Button} from '@/components/ui/button/Button'
import {Dialog} from '@/components/ui/dialog-atoms/DialogAtoms'
import {css, styled} from 'styled-components'

export const StyledDialog = styled(Dialog)(
    ({theme: {spacing}}) => css`
        top: ${spacing * 5}px;
        bottom: ${spacing * 5}px;
        right: ${spacing * 5}px;
        left: unset;
        width: 450px;
        transform: unset;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr) auto;
        overflow: hidden;
    `
)

export const StyledVisibilityGroupButton = styled(Button)(
    ({theme: {palette}}) => css`
        color: ${palette.primary[500]};
        text-decoration: underline;
        &:hover {
            color: ${palette.primary[600]};
        }
    `
)

export const StyledVisibilityGroupRow = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: ${spacing * 2.5}px 0;
        border-bottom: 1px solid ${palette.neutral[300]};
    `
)
